
import React, { createContext, useContext, ReactNode } from 'react';

interface NavigationContextType {
  isNavigationVisible: boolean;
  toggleNavigation: () => void;
  showNavigation: () => void;
  hideNavigation: () => void;
}

const NavigationContext = createContext<NavigationContextType | undefined>(undefined);

interface NavigationProviderProps {
  children: ReactNode;
  defaultVisible?: boolean;
}

// This context has been deprecated in favor of SidebarContext
// It's kept as a stub for backward compatibility
export const NavigationProvider: React.FC<NavigationProviderProps> = ({ 
  children
}) => {
  const value = {
    isNavigationVisible: false,
    toggleNavigation: () => {},
    showNavigation: () => {},
    hideNavigation: () => {}
  };

  return (
    <NavigationContext.Provider value={value}>
      {children}
    </NavigationContext.Provider>
  );
};

export const useNavigationContext = (): NavigationContextType => {
  const context = useContext(NavigationContext);
  if (context === undefined) {
    // Return stub implementation instead of throwing error
    return {
      isNavigationVisible: false,
      toggleNavigation: () => {},
      showNavigation: () => {},
      hideNavigation: () => {}
    };
  }
  return context;
};
